module.exports = __webpack_public_path__ + "img/homeTag-icon-4.9579f697.svg";